import { NotificationsToasts } from 'vscode/vscode/vs/workbench/browser/parts/notifications/notificationsToasts';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { NotificationService } from './vscode/src/vs/workbench/services/notification/common/notificationService.js';
import { INotificationService } from 'vscode/vscode/vs/platform/notification/common/notification.service';
import { getClientArea } from 'vscode/vscode/vs/base/browser/dom';
import { registerNotificationCommands } from 'vscode/vscode/vs/workbench/browser/parts/notifications/notificationsCommands';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { NotificationsCenter } from 'vscode/vscode/vs/workbench/browser/parts/notifications/notificationsCenter';
import { NotificationsAlerts } from 'vscode/vscode/vs/workbench/browser/parts/notifications/notificationsAlerts';
import { NotificationsTelemetry } from 'vscode/vscode/vs/workbench/browser/parts/notifications/notificationsTelemetry';
import { ILayoutService } from 'vscode/vscode/vs/platform/layout/browser/layoutService.service';
import { NotificationsStatus } from 'vscode/vscode/vs/workbench/browser/parts/notifications/notificationsStatus';
import { onRenderWorkbench } from 'vscode/lifecycle';

onRenderWorkbench(async (accessor) => {
    const container = accessor.get(ILayoutService).mainContainer;
    const model = accessor.get(INotificationService).model;
    const instantiationService = accessor.get(IInstantiationService);
    setTimeout(() => {
        const notificationsCenter = instantiationService.createInstance(NotificationsCenter, container, model);
        const notificationsToasts = instantiationService.createInstance(NotificationsToasts, container, model);
        instantiationService.createInstance(NotificationsAlerts, model);
        const notificationsStatus = instantiationService.createInstance(NotificationsStatus, model);
        instantiationService.createInstance(NotificationsTelemetry);
        notificationsCenter.onDidChangeVisibility(() => {
            notificationsStatus.update(notificationsCenter.isVisible, notificationsToasts.isVisible);
            notificationsToasts.update(notificationsCenter.isVisible);
        });
        notificationsToasts.onDidChangeVisibility(() => {
            notificationsStatus.update(notificationsCenter.isVisible, notificationsToasts.isVisible);
        });
        registerNotificationCommands(notificationsCenter, notificationsToasts, model);
        notificationsToasts.layout(getClientArea(container));
    });
});
function getServiceOverride() {
    return {
        [( INotificationService.toString())]: new SyncDescriptor(NotificationService, undefined, true)
    };
}

export { getServiceOverride as default };
